import { render, staticRenderFns } from "./sourceManage.vue?vue&type=template&id=39d536cd&scoped=true&"
import script from "./sourceManage.vue?vue&type=script&lang=js&"
export * from "./sourceManage.vue?vue&type=script&lang=js&"
import style0 from "./sourceManage.vue?vue&type=style&index=0&id=39d536cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d536cd",
  null
  
)

export default component.exports